import { defineComponent, type FunctionalComponent } from 'vue'
import EmptyState from 'components/empty-state'
import InfoCircle from 'assets/img/svg/icons/info-circle.svg?url'
import LinkIcon from 'assets/img/svg/icons/chain-link.svg?url'
import Button from 'components/button'
import * as Sentry from '@sentry/browser'
import type { UseProviderImport } from '../../hooks/useProviderImport'
import { patchModal } from 'components/modal/store'
import { sendFeaturebaseFeedback } from '@/integrations/featurebase/utils'

export const FinsquidError = defineComponent<{
  importAssets: UseProviderImport;
}>(
  (props) => {
    const loading = ref<boolean>(false)
    const EmptyStateAction: FunctionalComponent = () => {
      return (
        <Button
          icon={{
            src: LinkIcon,
            stroke: 'currentColor',
            size: 16
          }}
          isLoading={loading.value}
          onClick={async () => {
            loading.value = true
            await nextTick()
            await props.importAssets.reset();
            patchModal((s) => {
              s.hideTopBar = true;
              return s;
            })
            loading.value = false
          }}
        >
          Try Again
        </Button>
      )
    }

    const provider = props.importAssets.provider.value?.displayName || 'the provider'

    const SupportString = () => {
      return (
        <div class="text-sm text-center text-gray-500 font-normal font-['Inter'] leading-[21px] mb-10">
          If this issue keeps appearing, please&nbsp;
          <a
            class="text-sm text-primary-500 hover:text-primary-600 font-bold font-['Inter'] underline leading-[21px] cursor-pointer"
            onClick={() => sendFeaturebaseFeedback()}
          >
            Contact Us
          </a>
          &nbsp;and we’ll help you out!
        </div>
      )
    }

    Sentry.captureException(
      new Error('User has reached the error screen in the finsquid import asset flow.')
    )

    return () => {
      return (
        <div class="w-full h-full flex flex-col items-center justify-center">
          <EmptyState
            title="Connection Was Unsuccesful!"
            subtitle={`There was an issue connecting to ${provider}, please try again!`}
            icon={{
              src: InfoCircle,
              size: '2rem',
              fill: '#9CA3AF',
              stroke: 'current-color'
            }}
            action={() => <EmptyStateAction />}
          />
          <SupportString />
        </div>
      )
    }
  },
  { props: ['importAssets'] }
)
